import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, requireAuth } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    requireAuth(location.pathname);
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
